import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log error to error reporting service
        console.error('Error caught by boundary:', error, errorInfo);
        this.setState({ errorInfo });

        // You can also log to an external service like Sentry here
        // logErrorToService(error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
        window.location.href = '/';
    };

    render() {
        const { t } = this.props;

        if (this.state.hasError) {
            return (
                <div className="error-boundary">
                    <div className="error-boundary__container">
                        <h1 className="error-boundary__title">{t('errors.somethingWentWrong')}</h1>
                        <p className="error-boundary__message">
                            {t('errors.unexpectedErrorDetected')}
                        </p>

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <details className="error-boundary__details">
                                <summary>{t('errors.technicalDetails')}</summary>
                                <pre className="error-boundary__stack">
                                    {this.state.error.toString()}
                                    {this.state.errorInfo?.componentStack}
                                </pre>
                            </details>
                        )}

                        <div className="error-boundary__actions">
                            <button
                                type="button"
                                onClick={this.handleReset}
                                className="btn btn-accept"
                            >
                                {t('errors.backToHome')}
                            </button>
                            <button
                                type="button"
                                onClick={() => window.location.reload()}
                                className="btn btn-secondary"
                            >
                                {t('errors.reloadPage')}
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    t: PropTypes.func.isRequired,
};

export default withTranslation()(ErrorBoundary);
